// import React from "react";
// import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";

// // Fix marker icon
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl:
//     "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
//   iconUrl:
//     "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
//   shadowUrl:
//     "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
// });

// // Top metro + 20 major cities
// const cities = [
//   { name: "Mumbai", lat: 19.076, lng: 72.8777 },
//   { name: "Delhi", lat: 28.6139, lng: 77.209 },
//   { name: "Bengaluru", lat: 12.9716, lng: 77.5946 },
//   { name: "Chennai", lat: 13.0827, lng: 80.2707 },
//   { name: "Kolkata", lat: 22.5726, lng: 88.3639 },
//   { name: "Hyderabad", lat: 17.385, lng: 78.4867 },
//   { name: "Pune", lat: 18.5204, lng: 73.8567 },
//   { name: "Ahmedabad", lat: 23.0225, lng: 72.5714 },
//   { name: "Jaipur", lat: 26.9124, lng: 75.7873 },
//   { name: "Chandigarh", lat: 30.7333, lng: 76.7794 },
//   { name: "Indore", lat: 22.7196, lng: 75.8577 },
//   { name: "Nagpur", lat: 21.1458, lng: 79.0882 },
//   { name: "Lucknow", lat: 26.8467, lng: 80.9462 },
//   { name: "Patna", lat: 25.5941, lng: 85.1376 },
//   { name: "Ranchi", lat: 23.3441, lng: 85.3096 },
//   { name: "Bhubaneswar", lat: 20.2961, lng: 85.8245 },
//   { name: "Guwahati", lat: 26.1445, lng: 91.7362 },
//   { name: "Kochi", lat: 9.9312, lng: 76.2673 },
//   { name: "Coimbatore", lat: 11.0168, lng: 76.9558 },
//   { name: "Trivandrum", lat: 8.5241, lng: 76.9366 },
// ];

// const OurNetworkMap = () => {
//   return (


// <>


//    <section
//         className="breadcrumb-section"
//         style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
//       >
//         <div className="container">
//           <div className="banner-content">
//             <h1>Our Network</h1>
//           </div>
//         </div>
//       </section>

//     <section className="network-map-section">
//       <div className="network-map-wrapper">
//         <MapContainer
//           center={[22.5937, 78.9629]}
//           zoom={5}
//           scrollWheelZoom={false}
//           className="network-map"
//         >
//           <TileLayer
//             url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//             attribution="© OpenStreetMap contributors"
//           />

//           {cities.map((city, i) => (
//             <Marker key={i} position={[city.lat, city.lng]}>
//               <Popup>{city.name}</Popup>
//             </Marker>
//           ))}
//         </MapContainer>
//       </div>
//     </section>
// </>
//   );
// };

// export default OurNetworkMap;


import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import CityDestinations from "../pages/CityDestinations";
import NetworkSection from "./NetworkSection ";

// Fix marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// Top metro + major cities
const cities = [
  { name: "Mumbai", lat: 19.076, lng: 72.8777 },
  { name: "Delhi", lat: 28.6139, lng: 77.209 },
  { name: "Bengaluru", lat: 12.9716, lng: 77.5946 },
  { name: "Chennai", lat: 13.0827, lng: 80.2707 },
  { name: "Kolkata", lat: 22.5726, lng: 88.3639 },
  { name: "Hyderabad", lat: 17.385, lng: 78.4867 },
  { name: "Pune", lat: 18.5204, lng: 73.8567 },
  { name: "Ahmedabad", lat: 23.0225, lng: 72.5714 },
  { name: "Jaipur", lat: 26.9124, lng: 75.7873 },
  { name: "Chandigarh", lat: 30.7333, lng: 76.7794 },
  { name: "Indore", lat: 22.7196, lng: 75.8577 },
  { name: "Nagpur", lat: 21.1458, lng: 79.0882 },
  { name: "Lucknow", lat: 26.8467, lng: 80.9462 },
  { name: "Patna", lat: 25.5941, lng: 85.1376 },
  { name: "Ranchi", lat: 23.3441, lng: 85.3096 },
  { name: "Bhubaneswar", lat: 20.2961, lng: 85.8245 },
  { name: "Guwahati", lat: 26.1445, lng: 91.7362 },
  { name: "Kochi", lat: 9.9312, lng: 76.2673 },
  { name: "Coimbatore", lat: 11.0168, lng: 76.9558 },
  { name: "Trivandrum", lat: 8.5241, lng: 76.9366 },
];

const OurNetworkMap = () => {
  return (
    <>
      <section
        className="breadcrumb-section"
        style={{
          backgroundImage: "url(/images/background/inner-banner-bg.jpg)",
        }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>Our Network</h1>
          </div>
        </div>
      </section>

      <section className="network-map-section">
        <div className="network-map-wrapper">
          <MapContainer
            center={[22.5937, 78.9629]}
            zoom={5}
            scrollWheelZoom={false}
            className="network-map"
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution="© OpenStreetMap contributors"
            />

            {cities.map((city, i) => (
              <Marker key={i} position={[city.lat, city.lng]}>
                <Popup>{city.name}</Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
      </section>

<CityDestinations/>
<NetworkSection/>

      <section className="network-content-section">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-lg-9 text-center">
        <h2 className="section-title">Our Pan-India Network</h2>
        <p className="section-subtitle">
          Seamless corporate mobility solutions across India’s major business hubs
        </p>
      </div>
    </div>

    <div className="row mt-4">
      <div className="col-lg-12">
        <p>
          <strong>Pune Corporate Cars India Private Limited</strong> operates a
          robust and reliable transportation network across India’s leading
          metropolitan and commercial cities. Our extensive presence enables
          us to deliver consistent, high-quality corporate mobility solutions
          for multinational corporations, IT parks, business travelers, and
          enterprise clients.
        </p>

        <p>
          We currently provide services in key metros including{" "}
          <strong>
            Mumbai, Delhi, Bengaluru, Chennai, Hyderabad, Kolkata, and Pune
          </strong>, along with fast-growing commercial centers such as{" "}
          <strong>
            Ahmedabad, Jaipur, Chandigarh, Indore, Nagpur, Lucknow, Kochi,
            Coimbatore, Trivandrum, Bhubaneswar, Guwahati, Ranchi, and Patna
          </strong>.
        </p>

        <p>
          Our nationwide coverage allows corporate clients to benefit from a
          <strong> single-point-of-contact, standardized service levels,</strong>{" "}
          and centralized billing across multiple cities. Whether it is daily
          employee transportation, airport transfers, long-term corporate
          leasing, or executive travel, our network ensures timely, safe, and
          professionally managed services.
        </p>

        <p>
          With experienced chauffeurs, well-maintained fleets, and strong local
          operational teams in every serviced city, we ensure compliance,
          reliability, and service excellence—no matter where your business
          takes you.
        </p>
      </div>
    </div>
  </div>
</section>

    </>
  );
};

export default OurNetworkMap;
